import { api } from '@/core/api';
import qs from 'querystring';

const baseUrl = 'api/sysparameter';

export const getByParameterName = (parameterName, academicYearId) =>
  api.get(`${baseUrl}/byparametername`, {
    params: { parameterName, academicYearId },
  });
export const getSysparameterByNames = async (params) => {
  return await api.get(`${baseUrl}/byparameternames`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
};
